// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

import { commonShortFieldLabels } from "./common-short-fields";
import { platformAdminAssetsObjectSpaces } from "./platform-admin-assets-object-spaces";

export const platformAdminAssetsManagement = {
  columns: {
    filename: "文件名",
    assetId: "资产 ID",
    objectSpace: "对象空间",
    storage: "存储",
    size: "大小",
    references: "引用",
    createdAt: commonShortFieldLabels.createdAt,
    actions: "操作",
    owner: "归属人",
    ownerSubject: "归属主体",
    uploader: "上传者",
    inUse: "使用中",
    service: "服务",
    scope: "作用域",
    resourceType: "资源类型",
    resourceId: "资源 ID",
    field: "字段",
    label: "说明",
    businessService: "业务服务",
    bindingCount: "绑定数",
    assetCountRef: "关联资产数",
    note: "备注",
    shareMode: "共享模式",
    shareState: "共享状态",
    ...platformAdminAssetsObjectSpaces.columns,
  },
  actions: {
    governanceDetail: "查看",
    share: "共享",
    clone: "克隆",
    uploadToMySpace: "上传文件",
    viewMySpacePolicy: "查看空间策略/配额",
    copyDownloadLink: "复制下载链接",
    editNote: "编辑备注",
    shareToPublic: "共享到公共",
    cancelPublicShare: "取消共享",
    copyToMySpaceRecommended: "复制到我的空间（推荐）",
    ...platformAdminAssetsObjectSpaces.actions,
  },
  drawer: {
    referenceBindingCatalogDetail: "绑定明细 · {service} / {scope} / {resourceType}",
    referenceAssetCatalogDetail: "关联资产 · {service} / {scope} / {resourceType}",
    ...platformAdminAssetsObjectSpaces.drawer,
  },
  fields: {
    note: "备注",
    ...platformAdminAssetsObjectSpaces.fields,
  },
  form: {
    removeAssetTitle: "删除文件",
    removeAssetDescription: "确认删除 {name} 吗？删除后若资产仍被引用，操作会被阻止。",
    assetNoteTitle: "编辑备注 · {name}",
    assetNoteTitleShort: "编辑备注",
    noSelectedAsset: "未选择文件",
    note: "备注",
    sharePublicTitle: "共享到公共",
    sharePublicDescription: "确认将 {name} 共享到公共共享目录吗？共享后归属仍保留在当前用户。",
    unsharePublicTitle: "取消共享",
    unsharePublicDescription:
      "确认取消 {name} 的公共共享吗？若该资产已被其他模块引用，操作会被阻止。",
    ...platformAdminAssetsObjectSpaces.form,
  },
  errors: {
    loadFailed: "资产中心数据读取失败",
    mySpaceLoadFailed: "我的空间读取失败",
    mySpaceUploadFailed: "我的空间上传失败",
    mySpaceDeleteFailed: "我的空间文件删除失败",
    mySpaceNoteUpdateFailed: "我的空间备注更新失败",
    publicBrandingLoadFailed: "公共品牌目录读取失败",
    publicBrandingDeleteFailed: "公共品牌目录文件删除失败",
    publicBrandingNoteUpdateFailed: "公共品牌目录备注更新失败",
    sharePublicFailed: "共享到公共失败",
    unsharePublicFailed: "取消共享失败",
    copyToMySpaceFailed: "复制到我的空间失败",
    cloneFailed: "克隆资产失败",
    uploadRequestIncomplete: "上传请求返回不完整",
    uploadCompleteMissingAsset: "上传完成后未返回 asset_id",
    governanceDetailLoadFailed: "资产治理详情读取失败",
    ...platformAdminAssetsObjectSpaces.errors,
  },
  messages: {
    sharePublicSuccess: "{name} 已共享到公共目录",
    unsharePublicSuccess: "{name} 已取消公共共享",
    copyToMySpaceSuccess: "{name} 已复制到我的空间",
    cloneSuccess: "资产已克隆到我的资产",
  },
  objects: {
    ...platformAdminAssetsObjectSpaces.objects,
  },
} as const;
